module.exports = __webpack_public_path__ + "media/images/facebook-ddf8c95a5fe76d4e165f4b3a2a023438.svg";